import {
  ButtonTracking,
  NavigationTracking,
  ScreenTracking,
  SCREEN_ASSET_ID
} from '../../domain/amplitude'

export const ScreenOpenedEvent: ScreenTracking = {
  asset_id: SCREEN_ASSET_ID,
  screen: 'signUp',
  heading: 'Let’s Get Started!',
  from_screen: 'device'
}

export const LoginButtonClickedEvent: ButtonTracking = {
  asset_id: 'nextButton',
  asset_text: 'Log in',
  screen: 'signUp'
}

export const NextButtonClickedEvent: ButtonTracking = {
  asset_id: 'nextButton',
  asset_text: 'NEXT',
  screen: 'signUp'
}

export const NavigationEvent: NavigationTracking = {
  asset_id: 'backButton',
  asset_text: '<',
  screen: 'signUp'
}
